<template>
  <div v-if="collectionPrevItem" class="absolute left-0 flex p-4 -translate-y-1/2 w-min top-1/2" data-testid="viewer-collection-prev-item-link">
    <a
      :href="collectionPrevItem.url"
      class="p-3 border rounded-full border-slate-200 dark:border-zinc-700 opacity-30 group-hover:opacity-100 group-hover:shadow-xl bg-slate-50 dark:bg-zinc-500 hover:bg-blue-500 hover:text-white hover:border-transparent active:bg-blue-800 focus-visible:ring focus-visible:ring-blue-500/50 focus:outline-none"
    >
      <Icon name="general.prevItem" size="base" />
      <span class="sr-only">Show previous item in collection</span>
    </a>
  </div>

  <div v-if="collectionNextItem" class="absolute right-0 flex p-4 -translate-y-1/2 w-min top-1/2" data-testid="viewer-collection-next-item-link">
    <a
      :href="collectionNextItem.url"
      class="p-3 border rounded-full border-slate-200 dark:border-zinc-700 fill-slate-200 dark:fill-zinc-700 opacity-30 group-hover:opacity-100 group-hover:shadow-lg bg-slate-50 dark:bg-zinc-500 hover:bg-blue-500 hover:text-white hover:border-transparent active:bg-blue-800 focus-visible:ring focus-visible:ring-blue-500/50 focus:outline-none"
    >
      <Icon name="general.nextItem" size="base" />
      <span class="sr-only">Show next item in collection</span>
    </a>
  </div>
</template>

<script lang="ts" setup>
import { useViewerItemStore } from '../store/useViewerItemStore';
import { storeToRefs } from 'pinia';
import { Icon } from '@/storybook/icon';

const viewerItemStore = useViewerItemStore();

const { collectionNextItem, collectionPrevItem } = storeToRefs(viewerItemStore);
</script>
